module.exports = __webpack_public_path__ + "img/高亮网络.8836d4de.svg";